import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export enum MatchedCuratorsSortBy {
  BEST_MATCH = 'best_match',
  LOWEST_PRICE = 'lowest_price',
  HIGHEST_PRICE = 'highest_price',
  RECENT_ACTIVITY = 'recent_activity',
}

export interface GetMatchedCuratorsParams {
  campaignId: string
  pageNumber?: number
  pageSize?: number
  curatorUserIds?: number[]
  sortBy?: MatchedCuratorsSortBy
}

export interface MatchedPlaylist {
  id: number
  matchedGenres: string[]
  playlistCover: string
  playlistUrl: string
  matchingPercent: number
  playlistName: string
  followers: number
}

export interface MatchedCurator {
  id: number
  retailPrice: number
  matchedPlaylists: MatchedPlaylist[]
  photoUrl: string | null
  firstName: string
  lastName: string
  lastActivity: string | null
  madePlacements: boolean
}

export interface GetMatchedCuratorsResponse {
  data: MatchedCurator[]
  total: number
}

const DEFAULT_PAGE_SIZE = 20

const matchedCuratorsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getMatchedCurators: builder.query<
      GetMatchedCuratorsResponse,
      GetMatchedCuratorsParams
    >({
      query: ({
        campaignId,
        pageNumber = 1,
        pageSize = DEFAULT_PAGE_SIZE,
        curatorUserIds,
        sortBy,
      }) => {
        const params = new URLSearchParams()
        params.append('pageNumber', pageNumber.toString())
        params.append('pageSize', pageSize.toString())

        if (curatorUserIds && curatorUserIds.length > 0) {
          curatorUserIds.forEach((id) => {
            params.append('curatorUserIds', id.toString())
          })
        }

        if (sortBy) {
          params.append('sortBy', sortBy)
        }

        return `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/matched-curators?${params.toString()}`
      },
      providesTags: ['MatchedCurators'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetMatchedCuratorsQuery } = matchedCuratorsApi
